<script>
import Multiselect from 'vue-multiselect'
import { ValidationProvider } from 'vee-validate'

export default {
    components: {
        Multiselect,
        ValidationProvider,
    },
    props: {
        label: {
            type: String,
            default: 'name',
        },
        id: {
            type: String,
            default: 'select',
        },
        placeholder: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: 'name',
        },
        options: {
            type: Array,
            default: () => [],
        },
        groupValues: {
            type: String,
            default: '',
        },
        groupLabel: {
            type: String,
            default: '',
        },
        groupSelect: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Object, Array, Number],
            default: () => [],
        },
        required: {
            type: Boolean,
            default: false,
        },
        asyncOptions: {
            type: Boolean,
            default: false,
        },
        showNoResults: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: String,
            default: '',
        },
        trackBy: {
            type: String,
            default: 'publicId',
        },
        closeOnSelect: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        filteredOptions() {
            if (this.options) {
                const filteredOpts = this.options.filter((option) => {
                    if (!this.hasStatus(option) || option.status) return option
                })
                return filteredOpts
            }
            return []
        },
    },
    methods: {
        hasStatus(option) {
            // eslint-disable-next-line no-prototype-builtins
            return Object.prototype.hasOwnProperty.call(option, 'status')
        },
    },
}
</script>

<template>
    <div>
        <label :for="id" class="col-form-label pt-0 multiselect-label">
            {{ name }}{{ required ? '*' : '' }}
        </label>
        <ValidationProvider v-slot="{ errors }" :rules="rules" :name="name">
            <Multiselect
                :id="id"
                :placeholder="placeholder || $t('Fields.select.selectOption')"
                :deselect-label="''"
                :select-label="''"
                :selected-label="''"
                :deselect-group-label="''"
                :select-group-label="''"
                :selected-group-label="''"
                :show-no-results="!asyncOptions"
                :internal-search="!asyncOptions"
                :name="name"
                :label="label"
                :value="value"
                :multiple="true"
                :options="filteredOptions"
                :group-values="groupValues"
                :group-label="groupLabel"
                :group-select="groupSelect"
                :track-by="trackBy"
                :close-on-select="closeOnSelect"
                class="mgb_input"
                :class="{ 'input-error': errors.length }"
                @search-change="$emit('search-change', $event)"
                @input="$emit('input', $event)"
            >
            </Multiselect>
            <span class="alert-text">
                {{ errors[0] }}
            </span>
        </ValidationProvider>
    </div>
</template>

<style lang="scss" scoped>
@import '@src/design/components/select';
</style>
